import React, { useEffect, useState } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import MainLayout from "./layouts/MainLayout";

import AdminLayout from "./layouts/AdminLayout";

import Home from "./page/client/Home";

// import About2 from "./page/client/About2";

import About from "./page/client/About";

import Login from "./page/login";

import Dashboard from "./page/admin/Dashboard";

import Posts from "./page/admin/Posts";

import Users from "./page/admin/Users";

import NotFound from "./page/NotFound";

import UnderConstruction from "./page/UnderConstruction";

import Partners from "./page/admin/Partners";

import { ToastContainer } from "react-toastify";

import Contact from "./page/client/Contact";

import DetailPost from "./page/client/DetailPost";

import { useSelector, useDispatch } from "react-redux";

import { fetchPartners } from "./features/admin/PartnerSlice";

import {
  fetchPublicPosts,
  fetchNotifications,
  fetchPosts,
} from "./features/admin/PostsSlice";

import LoadingScreen from "./components/client/Loading";

import Roles from "./page/admin/Roles";

import ProductDetailPage from "./page/client/ProductDetail";

import Medias from "./page/admin/Medias";

import AdvertisementMedias from "./page/admin/AdvertisementMedias";

import Category from "./page/admin/Category";

import PermissionCategoty from "./page/admin/PermissionCategory";

import Products from "./page/admin/Products";

import VideoGallery from "./page/client/Video";

import ProductList from "./page/client/ProductList";

import Video from "./page/admin/Video";

import PublicMembershipDisplay from "./page/client/PublicMembershipDisplay";

import MemberDetailView from "./page/client/MemberDetailView";

import { fetchCategoryByTypePublic } from "./features/admin/CategorySlice";

import News from "./page/client/News";

import NotificationClient from "./page/client/Notification";

import Activities from "./page/client/Activities";

import ShoppingCart from "./page/client/Cart";

import { fetchUsersPublic } from "./features/admin/UserSlice";

import Orders from "./page/admin/Orders";

import Coupons from "./page/admin/Coupons";

import OrdersHistory from "./page/admin/OrdersHistory";

import Notification from "./page/admin/Notification";

import Criteria from "./page/admin/Criteria";

import DetailNoti from "./page/client/DetailNoti";

import Registration from "./page/admin/Registration";

import Feedback from "./page/admin/Feedback";

import AdminContact from "./page/admin/Contact";

import ToastNotification from "./components/ToastNotification";

import ChangePassword from "./page/admin/ChangePassword";

import MembershipFees from "./page/admin/MembershipFees";

import AuthCallback from "./page/client/AuthCallback";

import "suneditor/dist/css/suneditor.min.css";

import PointCriteriaSettings from "./page/admin/PointCriteriaSettings";

import ActivityScoring from "./page/admin/ActivityScoring";

import ProductRequest from "./page/admin/ProductRequest";

import ImageGallery from "./page/client/Image";

import WelcomeCardTemplates from "./page/admin/WellcomeCardTemplates";

import EventInvitationCardTemplates from "./page/admin/EventInvitationCardTemplates";

import SystemSettings from "./page/admin/SystemSettings";

// import ButtonCart from "./components/ButtonCart";

const userId = localStorage.getItem("userId");

const TRIAL_LIMIT_ENABLED = false;
const TRIAL_EXPIRED_AT = new Date("2026-08-08T23:59:59+07:00").getTime();
const TRIAL_DISMISSED_SESSION_KEY = "trial_notice_dismissed_session";
const TRIAL_SUPPORT_PHONE = "0847881010";
const TRIAL_SUPPORT_PERSON = "Duy";

const getTrialRouteGroup = (pathname) => {
  return pathname.startsWith("/admin") ? "admin" : "client";
};

const getTrialDismissedSession = () => {
  const navigationEntries =
    window.performance?.getEntriesByType?.("navigation") || [];
  const isReload =
    navigationEntries[0]?.type === "reload" ||
    window.performance?.navigation?.type === 1;

  if (isReload) {
    sessionStorage.removeItem(TRIAL_DISMISSED_SESSION_KEY);
    return false;
  }

  return sessionStorage.getItem(TRIAL_DISMISSED_SESSION_KEY) === "1";
};

const formatTrialTimeLeft = (timeLeft) => {
  const safeTimeLeft = Math.max(timeLeft, 0);
  const days = Math.floor(safeTimeLeft / (24 * 60 * 60 * 1000));
  const hours = Math.floor(
    (safeTimeLeft % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000),
  );
  const minutes = Math.floor(
    (safeTimeLeft % (60 * 60 * 1000)) / (60 * 1000),
  );
  const seconds = Math.floor((safeTimeLeft % (60 * 1000)) / 1000);

  return {
    days,
    hours: String(hours).padStart(2, "0"),
    minutes: String(minutes).padStart(2, "0"),
    seconds: String(seconds).padStart(2, "0"),
  };
};

const TrialCountdownCard = ({ timeLeft, onClose }) => {
  const { days, hours, minutes, seconds } = formatTrialTimeLeft(timeLeft);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/35 px-4">
      <div className="relative w-full max-w-2xl overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="h-2 bg-yellow-400" />

        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-2xl font-bold leading-none text-gray-500 transition hover:bg-gray-200 hover:text-gray-800"
        >
          ×
        </button>

        <div className="px-5 py-10 text-center">
          <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full border-2 border-yellow-100 bg-yellow-50 text-yellow-500">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
              <path d="M12 9v4" />
              <path d="M12 17h.01" />
            </svg>
          </div>

          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Sắp hết hạn dùng thử phần mềm
          </h2>

          <p className="mx-auto mt-3 max-w-lg text-base leading-7 text-gray-600">
            Thời gian dùng thử của phần mềm sắp kết thúc. Vui lòng liên hệ{" "}
            <span className="text-lg font-bold text-yellow-600">
              {TRIAL_SUPPORT_PERSON}
            </span>{" "}
            qua số{" "}
            <span className="text-lg font-bold text-yellow-600">
              {TRIAL_SUPPORT_PHONE}
            </span>{" "}
            để được hỗ trợ gia hạn.
          </p>

          <div className="mt-8 grid grid-cols-4 gap-4">
            <div className="rounded-2xl bg-yellow-50 px-3 py-5 text-center">
              <div className="text-5xl font-bold text-yellow-600">{days}</div>
              <div className="mt-2 text-xs font-semibold uppercase text-gray-500">
                Ngày
              </div>
            </div>

            <div className="rounded-2xl bg-yellow-50 px-3 py-5 text-center">
              <div className="text-5xl font-bold text-yellow-600">{hours}</div>
              <div className="mt-2 text-xs font-semibold uppercase text-gray-500">
                Giờ
              </div>
            </div>

            <div className="rounded-2xl bg-yellow-50 px-3 py-5 text-center">
              <div className="text-5xl font-bold text-yellow-600">
                {minutes}
              </div>
              <div className="mt-2 text-xs font-semibold uppercase text-gray-500">
                Phút
              </div>
            </div>

            <div className="rounded-2xl bg-yellow-50 px-3 py-5 text-center">
              <div className="text-5xl font-bold text-yellow-600">
                {seconds}
              </div>
              <div className="mt-2 text-xs font-semibold uppercase text-gray-500">
                Giây
              </div>
            </div>
          </div>

          <div className=" mt-8 rounded-2xl bg-yellow-50 px-6 py-5 text-center text-base leading-8 text-gray-700">
            Phần mềm cần được gia hạn, vui lòng liên hệ{" "}
            <span className="text-xl font-bold text-yellow-700">
              {TRIAL_SUPPORT_PHONE}
            </span>{" "}
            (
            <span className="text-xl font-bold text-yellow-700">
              {TRIAL_SUPPORT_PERSON}
            </span>
            ) để được hỗ trợ.
          </div>

          <a
            href={`tel:${TRIAL_SUPPORT_PHONE}`}
            className="mt-6 flex h-14 w-full items-center justify-center gap-2 rounded-lg bg-yellow-500 text-base font-bold text-white shadow-sm transition hover:bg-yellow-600"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.35 1.9.66 2.8a2 2 0 0 1-.45 2.11L8.05 9.9a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.31 1.84.53 2.8.66A2 2 0 0 1 22 16.92Z" />
            </svg>
            Gọi ngay {TRIAL_SUPPORT_PHONE}
          </a>
        </div>
      </div>
    </div>
  );
};

const TrialExpiredScreen = () => {
  return (
    <div className="fixed inset-0 z-[99999] flex min-h-screen items-center justify-center bg-black/55 px-4">
      <div className="w-full max-w-2xl overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="h-2 bg-red-500" />

        <div className="px-5 py-10 text-center">
          <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full border-2 border-red-100 bg-red-50 text-red-500">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
              <path d="M12 9v4" />
              <path d="M12 17h.01" />
            </svg>
          </div>

          <h1 className="mt-6 text-3xl font-bold text-gray-900">
            Hạn dùng thử phần mềm đã hết
          </h1>

          <p className="mx-auto mt-3 max-w-lg text-base leading-7 text-gray-600">
            Vui lòng liên hệ{" "}
            <span className="text-lg font-bold text-red-500">
              {TRIAL_SUPPORT_PERSON}
            </span>{" "}
            qua số{" "}
            <span className="text-lg font-bold text-red-500">
              {TRIAL_SUPPORT_PHONE}
            </span>{" "}
            để được hỗ trợ gia hạn.
          </p>

          <div className="mt-8 rounded-2xl bg-red-50 px-6 py-5 text-center text-base leading-8 text-gray-700">
            Phần mềm cần được gia hạn, vui lòng liên hệ{" "}
            <span className="text-xl font-bold text-red-600">
              {TRIAL_SUPPORT_PHONE}
            </span>{" "}
            (
            <span className="text-xl font-bold text-red-600">
              {TRIAL_SUPPORT_PERSON}
            </span>
            ) để được hỗ trợ.
          </div>

          <a
            href={`tel:${TRIAL_SUPPORT_PHONE}`}
            className="mt-6 flex h-14 w-full items-center justify-center gap-2 rounded-lg bg-red-500 text-base font-bold text-white shadow-sm transition hover:bg-red-600"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.35 1.9.66 2.8a2 2 0 0 1-.45 2.11L8.05 9.9a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.31 1.84.53 2.8.66A2 2 0 0 1 22 16.92Z" />
            </svg>
            Gọi ngay {TRIAL_SUPPORT_PHONE}
          </a>
        </div>
      </div>
    </div>
  );
};

const TrialNotice = ({ timeLeft, userId }) => {
  const location = useLocation();

  const routeGroup = getTrialRouteGroup(location.pathname);

  const [activeRouteGroup, setActiveRouteGroup] = useState(routeGroup);
  const [trialNoticeDismissed, setTrialNoticeDismissed] = useState(
    getTrialDismissedSession,
  );

  useEffect(() => {
    if (activeRouteGroup !== routeGroup) {
      sessionStorage.removeItem(TRIAL_DISMISSED_SESSION_KEY);
      setTrialNoticeDismissed(false);
      setActiveRouteGroup(routeGroup);
    }
  }, [activeRouteGroup, routeGroup]);

  const handleCloseTrialNotice = () => {
    sessionStorage.setItem(TRIAL_DISMISSED_SESSION_KEY, "1");
    setTrialNoticeDismissed(true);
  };

  if (
    !TRIAL_LIMIT_ENABLED ||
    userId != 1 ||
    trialNoticeDismissed ||
    timeLeft <= 0
  ) {
    return null;
  }

  return (
    <TrialCountdownCard
      timeLeft={timeLeft}
      onClose={handleCloseTrialNotice}
    />
  );
};

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");

  return permissions
    ? JSON.parse(permissions)?.map((p) => p.permissionSlug)
    : [];
};

const DataLoader = ({ children }) => {
  const dispatch = useDispatch();

  const { status: partnerStatus } = useSelector((state) => state.partners);

  const { status: postsStatus } = useSelector((state) => state.posts);

  const { authPostStatus, authNotificationStatus } = useSelector(
    (state) => state.posts,
  );

  useEffect(() => {
    const loadData = async () => {
      if (partnerStatus === "idle") {
        dispatch(fetchPartners());

        dispatch(
          fetchCategoryByTypePublic(
            "navbar,notification,training_recruitment,practice_certificate,legal_document,cadoor",
          ),
        );

        dispatch(fetchUsersPublic());
      }

      if (postsStatus === "idle") {
        dispatch(
          fetchCategoryByTypePublic(
            "navbar,notification,training_recruitment,practice_certificate,legal_document,cadoor",
          ),
        );

        await dispatch(fetchPublicPosts());
      }

      if (userId && authPostStatus === "idle") {
        dispatch(fetchPosts());
      }

      if (userId && authNotificationStatus === "idle") {
        dispatch(fetchNotifications());
      }
    };

    loadData();
  }, [dispatch, partnerStatus, postsStatus]);

  if (partnerStatus === "loading" || postsStatus === "loading") {
    return <LoadingScreen />;
  }

  if (partnerStatus === "failed" || postsStatus === "failed") {
    return <div>Error loading data</div>;
  }

  if (partnerStatus === "succeeded" && postsStatus === "succeeded") {
    return children;
  }

  return null;
};

const hasPermission = (requiredPermission) => {
  const userId = localStorage.getItem("userId");

  if (userId == 1) {
    return true;
  }

  const userPermissions = getUserPermissions();

  return userPermissions.includes(requiredPermission);
};

function App() {
  const [trialTimeLeft, setTrialTimeLeft] = useState(
    TRIAL_EXPIRED_AT - Date.now(),
  );

  useEffect(() => {
    if (!TRIAL_LIMIT_ENABLED) {
      return undefined;
    }

    const timer = setInterval(() => {
      setTrialTimeLeft(TRIAL_EXPIRED_AT - Date.now());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const isAuthenticated = () => {
    return localStorage.getItem("access_token_bccu");

    // &&

    // localStorage.getItem("type_user") === "admin"
  };

  const userId = localStorage.getItem("userId");

  // const isAdminRoute =

  // window.location.pathname.startsWith("/admin") ||

  // window.location.pathname.startsWith("/login") ||

  // !userId;

  if (TRIAL_LIMIT_ENABLED && userId == 1 && trialTimeLeft <= 0) {
    return <TrialExpiredScreen />;
  }

  return (
    <Router>
      <DataLoader>
        <ToastContainer autoClose={1000} />

        <ToastNotification />

        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />

            <Route path="/login" element={<Login />} />

            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route
              path="/gioi-thieu"
              element={
                <Navigate
                  to="/gioi-thieu/qua-trinh-hinh-thanh-va-phat-trien"
                  replace
                />
              }
            />

            <Route path="/gioi-thieu/:slug" element={<About />} />

            <Route path="/lien-he" element={<Contact />} />

            <Route path="/post/:slug" element={<DetailPost />} />

            <Route path="/san-pham/:slug" element={<ProductDetailPage />} />

            <Route path="/video" element={<VideoGallery />} />

            <Route path="/image" element={<ImageGallery />} />

            <Route path="/danh-sach-san-pham" element={<ProductList />} />

            <Route path="/tin-tuc-su-kien" element={<News />} />

            <Route path="/hoat-dong" element={<Activities />} />

            <Route path="/hoat-dong/:slug" element={<News />} />

            <Route
              path="/dao-tao-tuyen-dung"
              element={
                <News
                  categoryType="training_recruitment"
                  pageTitle="Đào tạo & tuyển dụng"
                />
              }
            />

            <Route
              path="/dao-tao-tuyen-dung/:slug"
              element={
                <News
                  categoryType="training_recruitment"
                  pageTitle="Đào tạo & tuyển dụng"
                />
              }
            />

            <Route
              path="/cap-chung-chi-hanh-nghe"
              element={
                <News
                  categoryType="practice_certificate"
                  pageTitle="Cấp chứng chỉ"
                />
              }
            />

            <Route
              path="/cap-chung-chi-hanh-nghe/:slug"
              element={
                <News
                  categoryType="practice_certificate"
                  pageTitle="Cấp chứng chỉ"
                />
              }
            />

            <Route
              path="/van-ban-phap-luat"
              element={
                <News
                  categoryType="legal_document"
                  pageTitle="Văn bản pháp luật"
                />
              }
            />

            <Route
              path="/van-ban-phap-luat/:slug"
              element={
                <News
                  categoryType="legal_document"
                  pageTitle="Văn bản pháp luật"
                />
              }
            />

            <Route
              path="/chi-hoi-nganh-cua"
              element={<News categoryType="cadoor" pageTitle="Chi hội Cadoor" />}
            />

            <Route
              path="/chi-hoi-nganh-cua/:slug"
              element={<News categoryType="cadoor" pageTitle="Chi hội Cadoor" />}
            />

            <Route path="/thong-bao/" element={<NotificationClient />} />

            <Route path="/thong-bao/:slug" element={<NotificationClient />} />

            <Route path="/thong-bao/:slug/:slug1" element={<DetailNoti />} />

            <Route
              path="/danh-sach-hoi-vien/:slug"
              element={<PublicMembershipDisplay />}
            />

            {userId && (
              <Route
                path="/danh-sach-hoi-vien"
                element={<PublicMembershipDisplay />}
              />
            )}

            <Route path="/thanh-vien/:slug" element={<MemberDetailView />} />

            <Route path="/gio-hang" element={<ShoppingCart />} />
          </Route>

          <Route
            path="/admin"
            element={
              isAuthenticated() ? (
                <AdminLayout />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />

            <Route path="dashboard" element={<Dashboard />} />

            {/* 🔹 Chỉ hiển thị nếu có quyền */}

            {hasPermission("POST_SHOW") && (
              <Route path="posts" element={<Posts />} />
            )}

            {hasPermission("USER_SHOW") && (
              <Route path="users" element={<Users />} />
            )}

            {hasPermission("MEMBERSHIP_FEE_SHOWS") && (
              <Route path="membershipfees" element={<MembershipFees />} />
            )}

            {/* {hasPermission("PARTNER_SHOW") && ( */}

            {hasPermission("COMPANY_SHOW") && (
              <Route path="partner" element={<Partners />} />
            )}

            {/* )} */}

            {hasPermission("ROLE_SHOW") && (
              <Route path="roles" element={<Roles />} />
            )}

            <Route path="media" element={<Medias />} />

            <Route
              path="advertisement-medias"
              element={<AdvertisementMedias />}
            />

            <Route path="change-password" element={<ChangePassword />} />

            <Route path="videos" element={<Video />} />

            <Route path="category" element={<Category />} />

            <Route path="permission-show" element={<PermissionCategoty />} />

            <Route path="product" element={<Products />} />

            <Route path="order" element={<Orders />} />

            {hasPermission("COUPON_SHOW") && (
              <Route path="coupon" element={<Coupons />} />
            )}

            {hasPermission("POST_SHOW") && (
              <Route path="notification" element={<Notification />} />
            )}

            <Route path="order-history" element={<OrdersHistory />} />

            {hasPermission("CRITERIA_SHOW") && (
              <Route path="criteria" element={<Criteria />} />
            )}

            {hasPermission("POINT_SETTINGS") && (
              <Route
                path="point-criteria-setting"
                element={<PointCriteriaSettings />}
              />
            )}

            {hasPermission("WELCOME_CARD_SHOW") && (
              <Route
                path="welcome-card-template"
                element={<WelcomeCardTemplates />}
              />
            )}

            {hasPermission("EVENT_INVITATION_CARD_SHOW") && (
              <Route
                path="event-invitation-card-template"
                element={<EventInvitationCardTemplates />}
              />
            )}

            {hasPermission("SETTING_SHOW") && (
              <Route path="system-settings" element={<SystemSettings />} />
            )}

            {hasPermission("REGISTER_SHOW") && (
              <Route path="registration" element={<Registration />} />
            )}

            {hasPermission("COMMENT_SHOW") && (
              <Route path="feedback" element={<Feedback />} />
            )}

            {/* {hasPermission("POINT_VIEW") && (

<Route path="point-log" element={<PointLog />} />

)} */}

            {hasPermission("POINT_VIEW") && (
              <Route path="point-log" element={<ActivityScoring />} />
            )}

            {hasPermission("CONTACT_SHOW") && (
              <Route path="contact" element={<AdminContact />} />
            )}

            {hasPermission("PRODUCT_REQUEST_SHOW") && (
              <Route path="product-request" element={<ProductRequest />} />
            )}
          </Route>

          <Route path="/ban-dieu-hanh" element={<Login />} />

          <Route path="*" element={<NotFound />} />

          <Route path="/hoat-dong/cong-dong" element={<UnderConstruction />} />

          {/* <Route path="/hoat-dong/tu-thien" element={<UnderConstruction />} /> */}

          <Route path="/tin-bao-chi" element={<UnderConstruction />} />

          <Route path="/van-ban" element={<UnderConstruction />} />

          {/* <Route path="/admin/roles" element={<UnderConstruction />} /> */}

          <Route
            path="/tin-tuc-su-kien/tin-moi"
            element={<UnderConstruction />}
          />

          <Route
            path="/tin-tuc-su-kien/su-kien-noi-bat"
            element={<UnderConstruction />}
          />
        </Routes>
      </DataLoader>

      <TrialNotice timeLeft={trialTimeLeft} userId={userId} />

      {/* {!isAdminRoute && <ButtonCart />} */}
    </Router>
  );
}

export default App;
